// extracted by mini-css-extract-plugin
export var arrow = "SaveToLibraryBanner-module--arrow--5db4b";
export var arrowNo = "SaveToLibraryBanner-module--arrow_no--19a74";
export var arrowYes = "SaveToLibraryBanner-module--arrow_yes--e51ba";
export var contentContainer = "SaveToLibraryBanner-module--contentContainer--5ea83";
export var contentTitle = "SaveToLibraryBanner-module--contentTitle--33184";
export var documentTitle = "SaveToLibraryBanner-module--documentTitle--934ee";
export var flex = "SaveToLibraryBanner-module--flex--fbecd";
export var flex1 = "SaveToLibraryBanner-module--flex_1--f57e5";
export var flexCenter = "SaveToLibraryBanner-module--flex_center--7aec1";
export var flexCenterCol = "SaveToLibraryBanner-module--flex_center_col--e4fbd";
export var flexCol = "SaveToLibraryBanner-module--flex_col--1b15e";
export var flexFixCenterCol = "SaveToLibraryBanner-module--flex_fix_center_col--cf480";
export var flexFixedCenterCol = "SaveToLibraryBanner-module--flex_fixed_center_col--16f60";
export var rotating = "SaveToLibraryBanner-module--rotating--c1464";
export var saveToLibraryButton = "SaveToLibraryBanner-module--saveToLibraryButton--33a7f";
export var saveToLibraryContainer = "SaveToLibraryBanner-module--saveToLibraryContainer--64e6f";
export var saveToLibraryIcon = "SaveToLibraryBanner-module--saveToLibraryIcon--8274b";